(function () {
  var SWIPE_THRESHOLD = 48;

  function parseStores(root) {
    var script = root.querySelector('[data-store-locator-data]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function getLightbox() {
    var lightbox = document.getElementById('store-locator-lightbox');
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.id = 'store-locator-lightbox';
    lightbox.className = 'store-locator-lightbox';
    lightbox.setAttribute('hidden', '');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.innerHTML =
      '<div class="store-locator-lightbox__backdrop" data-store-lightbox-close></div>' +
      '<button type="button" class="store-locator-lightbox__close" data-store-lightbox-close aria-label="Close">&times;</button>' +
      '<div class="store-locator-lightbox__panel">' +
      '<div class="store-locator-lightbox__header">' +
      '<h3 class="store-locator-lightbox__title"></h3>' +
      '<p class="store-locator-lightbox__counter"></p>' +
      '</div>' +
      '<div class="store-locator-lightbox__stage" data-store-lightbox-stage>' +
      '<button type="button" class="store-locator-lightbox__nav store-locator-lightbox__nav--prev" data-store-lightbox-prev aria-label="Previous image">&#10094;</button>' +
      '<img class="store-locator-lightbox__image" alt="" draggable="false">' +
      '<button type="button" class="store-locator-lightbox__nav store-locator-lightbox__nav--next" data-store-lightbox-next aria-label="Next image">&#10095;</button>' +
      '</div>' +
      '<p class="store-locator-lightbox__hint">Swipe or tap arrows to browse</p>' +
      '</div>';
    document.body.appendChild(lightbox);
    bindLightboxEvents(lightbox);
    return lightbox;
  }

  function bindLightboxEvents(lightbox) {
    if (lightbox.dataset.bound === 'true') return;
    lightbox.dataset.bound = 'true';

    var img = lightbox.querySelector('.store-locator-lightbox__image');
    var stage = lightbox.querySelector('[data-store-lightbox-stage]');
    var titleEl = lightbox.querySelector('.store-locator-lightbox__title');
    var counterEl = lightbox.querySelector('.store-locator-lightbox__counter');
    var hintEl = lightbox.querySelector('.store-locator-lightbox__hint');
    var images = [];
    var index = 0;
    var open = false;
    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var deltaY = 0;
    var swiping = false;

    function render(animate) {
      if (!images.length) return;
      index = Math.max(0, Math.min(index, images.length - 1));
      img.src = images[index].src;
      img.alt = images[index].alt || '';
      counterEl.textContent = (index + 1) + ' / ' + images.length;
      lightbox.classList.toggle('has-nav', images.length > 1);
      if (hintEl) hintEl.hidden = images.length < 2;
      if (animate) {
        img.style.opacity = '0.35';
        requestAnimationFrame(function () {
          img.style.transition = 'opacity 0.28s ease';
          img.style.opacity = '1';
        });
      } else {
        img.style.transition = '';
        img.style.opacity = '1';
      }
    }

    function close() {
      open = false;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('hidden', '');
      document.documentElement.classList.remove('store-locator-lightbox-open');
      images = [];
      index = 0;
    }

    function next() {
      if (images.length < 2) return;
      index = (index + 1) % images.length;
      render(true);
    }

    function prev() {
      if (images.length < 2) return;
      index = (index - 1 + images.length) % images.length;
      render(true);
    }

    lightbox._openStore = function (store, startIndex) {
      if (!store || !store.images || !store.images.length) return;
      images = store.images;
      index = startIndex || 0;
      titleEl.textContent = store.title || '';
      render(false);
      lightbox.removeAttribute('hidden');
      lightbox.classList.add('is-open');
      document.documentElement.classList.add('store-locator-lightbox-open');
      open = true;
    };

    lightbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-store-lightbox-close]')) close();
      else if (e.target.closest('[data-store-lightbox-next]')) next();
      else if (e.target.closest('[data-store-lightbox-prev]')) prev();
    });

    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });

    function onSwipeStart(x, y) {
      if (!open) return;
      startX = x;
      startY = y;
      deltaX = 0;
      deltaY = 0;
      swiping = true;
    }

    function onSwipeMove(x, y) {
      if (!swiping) return;
      deltaX = x - startX;
      deltaY = y - startY;
    }

    function onSwipeEnd() {
      if (!swiping) return;
      swiping = false;
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD) {
        if (deltaX < 0) next();
        else prev();
      }
    }

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) onSwipeStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 1) onSwipeMove(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    stage.addEventListener('touchend', onSwipeEnd);
  }

  function initSection(section) {
    if (!section || section.dataset.storeLocatorInit === 'true') return;
    section.dataset.storeLocatorInit = 'true';

    var stores = parseStores(section);
    if (!stores.length) return;

    var cityTabs = section.querySelectorAll('[data-city-key].store-locator__city-tab');
    var locationTabs = section.querySelectorAll('.store-locator__location-tab');
    var imageEl = section.querySelector('[data-store-image]');
    var placeholderEl = section.querySelector('[data-store-placeholder]');
    var prevBtn = section.querySelector('[data-store-prev]');
    var nextBtn = section.querySelector('[data-store-next]');
    var expandBtn = section.querySelector('[data-store-expand]');
    var stage = section.querySelector('[data-store-stage]');
    var lightbox = getLightbox();

    var activeCity = '';
    var activeStoreIndex = 0;
    var imageIndex = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeDeltaX = 0;
    var swipeDeltaY = 0;
    var swiping = false;

    function currentStore() {
      return stores[activeStoreIndex] || null;
    }

    function setCity(cityKey, preferStoreIndex) {
      activeCity = cityKey;
      cityTabs.forEach(function (tab) {
        var on = tab.getAttribute('data-city-key') === cityKey;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      var firstVisible = -1;
      locationTabs.forEach(function (tab) {
        var match = tab.getAttribute('data-city-key') === cityKey;
        tab.hidden = !match;
        if (match && firstVisible < 0) {
          firstVisible = parseInt(tab.getAttribute('data-store-index'), 10);
        }
      });

      var nextIndex = firstVisible;
      if (
        typeof preferStoreIndex === 'number' &&
        stores[preferStoreIndex] &&
        stores[preferStoreIndex].cityKey === cityKey
      ) {
        nextIndex = preferStoreIndex;
      }
      if (nextIndex < 0) nextIndex = 0;
      setStore(nextIndex);
    }

    function setStore(index) {
      if (!stores[index]) return;
      activeStoreIndex = index;
      imageIndex = 0;

      locationTabs.forEach(function (tab) {
        var i = parseInt(tab.getAttribute('data-store-index'), 10);
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      renderGallery(false);
    }

    function renderGallery(animate) {
      var store = currentStore();
      var images = store && store.images ? store.images : [];
      var hasImages = images.length > 0;

      if (placeholderEl) placeholderEl.hidden = hasImages;
      if (imageEl) imageEl.hidden = !hasImages;

      if (prevBtn) prevBtn.hidden = images.length < 2;
      if (nextBtn) nextBtn.hidden = images.length < 2;
      if (expandBtn) expandBtn.hidden = !hasImages;

      if (!hasImages || !imageEl) return;

      imageIndex = Math.max(0, Math.min(imageIndex, images.length - 1));
      var item = images[imageIndex];

      function apply() {
        imageEl.src = item.src;
        imageEl.alt = item.alt || store.title || '';
        imageEl.classList.remove('is-fading');
      }

      if (animate) {
        imageEl.classList.add('is-fading');
        setTimeout(apply, 160);
      } else {
        apply();
      }
    }

    function nextImage() {
      var store = currentStore();
      if (!store || !store.images || store.images.length < 2) return;
      imageIndex = (imageIndex + 1) % store.images.length;
      renderGallery(true);
    }

    function prevImage() {
      var store = currentStore();
      if (!store || !store.images || store.images.length < 2) return;
      imageIndex = (imageIndex - 1 + store.images.length) % store.images.length;
      renderGallery(true);
    }

    cityTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setCity(tab.getAttribute('data-city-key'));
      });
    });

    locationTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.getAttribute('data-store-index'), 10);
        var cityKey = tab.getAttribute('data-city-key');
        if (cityKey !== activeCity) setCity(cityKey, idx);
        else setStore(idx);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', prevImage);
    if (nextBtn) nextBtn.addEventListener('click', nextImage);
    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        var store = currentStore();
        if (store) lightbox._openStore(store, imageIndex);
      });
    }

    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        swiping = true;
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        swipeDeltaX = 0;
        swipeDeltaY = 0;
      }, { passive: true });

      stage.addEventListener('touchmove', function (e) {
        if (!swiping || e.touches.length !== 1) return;
        swipeDeltaX = e.touches[0].clientX - swipeStartX;
        swipeDeltaY = e.touches[0].clientY - swipeStartY;
      }, { passive: true });

      stage.addEventListener('touchend', function () {
        if (!swiping) return;
        swiping = false;
        if (Math.abs(swipeDeltaX) > Math.abs(swipeDeltaY) && Math.abs(swipeDeltaX) > SWIPE_THRESHOLD) {
          if (swipeDeltaX < 0) nextImage();
          else prevImage();
        }
      });
    }

    var firstCity =
      (cityTabs[0] && cityTabs[0].getAttribute('data-city-key')) ||
      stores[0].cityKey ||
      '';
    setCity(firstCity, 0);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-store-locator]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target && e.target.querySelector('[data-store-locator]');
    if (section) delete section.dataset.storeLocatorInit;
  });
})();